module.exports = {"fontSizeBase":"1rem","h1FontSize":"2.0272865295410156rem","h2FontSize":"1.802032470703125rem","h3FontSize":"1.601806640625rem","h4FontSize":"1.423828125rem","h5FontSize":"1.265625rem","h6FontSize":"1.125rem"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/inline-styles/variables/typography.json
// module id = 36
// module chunks = 0